import { Col, Form, Input, Row, Select } from "antd";
import { Utils } from "../../Utilities/Utils";
import React from "react";

const SequenceSection = ({ form, isEdit, PracticeUpdateTypes, title, nameKey }: any) => {
    
    return (
        <Form form={form}>
            <Row className="font-bold pt-1">{title}</Row>
            <Col md={12} xl={12} xxl={8} style={{padding:0}}>
                <Form.Item
                        className="custom-form-item"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 18}}
                        label="Sequences type"
                        name={["sequences", nameKey, "type"]}
                    >
                        <Select
                            className="line-height-28"
                            placeholder="Sequences type"
                            disabled={
                                isEdit.type === PracticeUpdateTypes
                                    ? false
                                    : true
                            }
                            options={[
                                { value: 0, label: "None" },
                                { value: 1, label: "Yearly" },
                                { value: 2, label: "Monthly" },
                            ]}
                        />
                    </Form.Item>
            </Col>
            <Row className="pt-1" style={{ paddingRight:8 }}>
                <Col md={6} xl={5} xxl={4}>
                        <Form.Item
                            className="custom-form-item"
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            label="Seperator"
                            name={["sequences", nameKey, "seperator"]}
                        >
                            <Input
                                className="line-height-28"
                                disabled={
                                    isEdit.type === PracticeUpdateTypes
                                        ? false
                                        : true
                                }
                            />
                        </Form.Item>
                    </Col>
                    <span
                        style={{
                            display: "flex",
                            alignItems: "flex-end",
                            fontWeight: 900,
                            padding: "0 6px 8px",
                        }}
                    >
                        -
                    </span>
                    <Col md={6} xl={8} xxl={6}>
                    <Form.Item
                            className="custom-form-item"
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 20 }}
                            label="Leading zero"
                            name={["sequences", nameKey, "leadingZero"]}
                        >
                            <Input
                                className="line-height-28"
                                onKeyPress={(e) => Utils.ValidateNumberOnly(e)}
                                disabled={
                                    isEdit.type === PracticeUpdateTypes
                                        ? false
                                        : true
                                }
                            />
                        </Form.Item>
                    </Col>
                    <span
                        style={{
                            display: "flex",
                            alignItems: "flex-end",
                        fontWeight: 900,
                        marginLeft: "-18px",
                            padding: "0 6px 8px",
                        }}
                    >
                        -
                    </span>
                    <Col md={6} xl={4} xxl={4}>
                        <Form.Item
                            className="custom-form-item"
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            label="Prefix"
                            name={["sequences", nameKey, "prefix"]}
                        >
                            <Input
                                className="line-height-28"
                                onKeyPress={(e) => Utils.ValidateCharAndNumberOnly(e)}
                                disabled={
                                    isEdit.type === PracticeUpdateTypes
                                        ? false
                                        : true
                                }
                            />
                        </Form.Item>
                    </Col>
                    <span
                        style={{
                            display: "flex",
                            alignItems: "flex-end",
                            fontWeight: 900,
                            padding: "0 6px 8px",
                        }}
                    >
                        -
                    </span>
                    <Col md={6} xl={4} xxl={4}>
                        <Form.Item
                            className="custom-form-item"
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            label="Suffix"
                            name={["sequences", nameKey, "postfix"]}
                        >
                            <Input
                                className="line-height-28"
                                onKeyPress={(e) => Utils.ValidateCharAndNumberOnly(e)}
                                disabled={
                                    isEdit.type === PracticeUpdateTypes
                                        ? false
                                        : true
                                }
                            />
                        </Form.Item>
                    </Col>
                </Row>
        </Form>
    );
}
export default SequenceSection;